// src/components/MobileAppOnboardingCard.jsx

import React, { useEffect, useState } from "react";

const EAS_INSTALL_URL =
  "https://expo.dev/accounts/limmy/projects/ghrianghraffy/builds/619dedcf-cc1d-4484-9434-39fd410f0aa2";

const MobileAppOnboardingCard = ({
  variant = "principal",
  storageKey = null,
  dismissible = true,
  onDownload,
}) => {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!storageKey || !dismissible) return;
    try {
      if (window.localStorage.getItem(storageKey) === "dismissed") {
        setDismissed(true);
      }
    } catch (err) {
      console.warn("localStorage unavailable:", err);
    }
  }, [storageKey, dismissible]);

  const handleDismiss = () => {
    if (!dismissible) return;
    setDismissed(true);
    if (storageKey) {
      try {
        window.localStorage.setItem(storageKey, "dismissed");
      } catch (err) {
        console.warn("Failed to save dismissed state:", err);
      }
    }
  };

  const handleDownloadClick = () => {
    if (onDownload) {
      onDownload();
    }
    // Let the browser follow the href to EAS normally
  };

  if (dismissed) return null;

  const isPrincipal = variant === "principal";

  return (
    <section
      style={{
        marginTop: "1.8rem",
        padding: "1.6rem",
        borderRadius: 20,
        background:
          "linear-gradient(135deg, rgba(14,110,190,0.98), rgba(8,64,130,0.98))",
        border: "1px solid rgba(0,255,175,0.4)",
        boxShadow: "0 20px 50px rgba(0,0,0,0.6)",
        color: "#e0f2fe",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Subtle sun glow */}
      <div
        style={{
          position: "absolute",
          top: -70,
          right: -70,
          width: 220,
          height: 220,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0,255,175,0.18) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      {dismissible && (
        <button
          onClick={handleDismiss}
          aria-label="Dismiss"
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            background: "none",
            border: "none",
            fontSize: 24,
            color: "rgba(255,255,255,0.7)",
            cursor: "pointer",
          }}
        >
          ×
        </button>
      )}

      <h3
        style={{
          margin: "0 0 0.6rem",
          fontSize: "1.26rem",
          color: "#fff",
        }}
      >
        {isPrincipal
          ? "Get the GhrianGhraffy App on your phone"
          : "Snap photos instantly with the GhrianGhraffy App"}
      </h3>

      <p
        style={{
          margin: "0 0 1.4rem",
          fontSize: "0.96rem",
          opacity: 0.95,
          lineHeight: 1.5,
        }}
      >
        {isPrincipal
          ? "Install the GhrianGhraffy App once and start sharing photos instantly."
          : "You'll use this App (not the GhrianGhraffy website) to take Photos. One-tap photo capture, offline drafts, and instant upload."}
      </p>

      {/* QR code + direct link */}
      <div style={{ textAlign: "center", marginBottom: 16 }}>
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(
            EAS_INSTALL_URL
          )}`}
          alt="Scan to install GhrianGhraffy (Android)"
          style={{
            width: 180,
            height: 180,
            border: "8px solid #fff",
            borderRadius: 16,
            boxShadow: "0 8px 20px rgba(0,0,0,0.4)",
          }}
        />
        <p style={{ margin: "12px 0 0", fontSize: "0.9rem" }}>
          <strong>Scan with your phone camera</strong> → installs instantly
        </p>
      </div>

      <div style={{ textAlign: "center" }}>
        <a
          href={EAS_INSTALL_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleDownloadClick}
          style={{
            display: "inline-block",
            padding: "0.8rem 1.6rem",
            background: "#00FFAF",
            color: "#0e6ebe",
            borderRadius: 999,
            fontWeight: "bold",
            fontSize: "1rem",
            textDecoration: "none",
          }}
        >
          📱 Download GhrianGhraffy for Android
        </a>
      </div>

      <p
        style={{
          margin: "1.2rem 0 0",
          fontSize: "0.82rem",
          opacity: 0.8,
          fontStyle: "italic",
          textAlign: "center",
        }}
      >
        iOS app coming very soon — we’ll email you the moment it’s live!
      </p>
    </section>
  );
};

export default MobileAppOnboardingCard;